// extracted by mini-css-extract-plugin
module.exports = {"root":"ThreeUp_root__2YWVi","slot":"ThreeUp_slot__1NT9Z"};